<template>
    <div>
        <maincontent>
            <template v-slot:header>
                <h1>{{ $t('pages.management_and_maintenance.title') }}</h1>
                <p>{{ $t('pages.management_and_maintenance.subtitle') }}</p>
            </template>

            <template v-slot:col1>
                <span
                    class="subtitle"
                >{{ $t('pages.management_and_maintenance.sections.we_manage_things.title') }}</span>
                <p>{{ $t('pages.management_and_maintenance.sections.we_manage_things.body') }}</p>

                <span
                    class="subtitle"
                >{{ $t('pages.management_and_maintenance.sections.lasting_performance.title') }}</span>
                <p>{{ $t('pages.management_and_maintenance.sections.lasting_performance.body') }}</p>
            </template>
            <template v-slot:col2>
                <span
                    class="subtitle"
                >{{ $t('pages.management_and_maintenance.sections.24_7_support.title') }}</span>
                <p>{{ $t('pages.management_and_maintenance.sections.24_7_support.body') }}</p>
            </template>
            <template v-slot:remark>
                <p
                    class="remark"
                    v-html="$t('pages.management_and_maintenance.sections.24_7_support.lead')"
                ></p>
            </template>
        </maincontent>

        <fullimage
            :img="require('@/assets/images/cell-phones-on-shelf-in-telecommunication-shop.jpg')"
            inverse
        >
            <p class="remark" v-html="$t('pages.management_and_maintenance.lead')"></p>
        </fullimage>

        <navigationgrid :showing="[false,true,true,true,true]"></navigationgrid>
    </div>
</template>

<script>
import homehero from "@/components/homehero.vue";
import fullimage from "@/components/fullimage.vue";
import navigationgrid from "@/components/navigationgrid.vue";
import navigationcard from "@/components/navigationcard.vue";
import wwdfooter from "@/components/wwdfooter.vue";
import maincontent from "@/components/maincontent.vue";

export default {
    components: {
        homehero: homehero,
        fullimage: fullimage,
        navigationgrid: navigationgrid,
        navigationcard: navigationcard,
        wwdfooter: wwdfooter,
        maincontent: maincontent
    }
};
</script>
